/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StatisticsResponse'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./StatisticsResponse'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.ClientStatisticsResponse = factory(root.GisServerApis.ApiClient, root.GisServerApis.StatisticsResponse);
  }
}(this, function(ApiClient, StatisticsResponse) {
  'use strict';




  /**
   * The ClientStatisticsResponse model module.
   * @module model/ClientStatisticsResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>ClientStatisticsResponse</code>.
   * The response for statistics groupped by client.
   * @alias module:model/ClientStatisticsResponse
   * @class
   */
  var exports = function() {
    var _this = this;




  };

  /**
   * Constructs a <code>ClientStatisticsResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ClientStatisticsResponse} obj Optional instance to populate.
   * @return {module:model/ClientStatisticsResponse} The populated <code>ClientStatisticsResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('clientId')) {
        obj['clientId'] = ApiClient.convertToType(data['clientId'], 'String');
      }
      if (data.hasOwnProperty('clientName')) {
        obj['clientName'] = ApiClient.convertToType(data['clientName'], 'String');
      }
      if (data.hasOwnProperty('data')) {
        obj['data'] = ApiClient.convertToType(data['data'], [StatisticsResponse]);
      }
    }
    return obj;
  }

  /**
   * The ID of the client.
   * @member {String} clientId
   */
  exports.prototype['clientId'] = undefined;
  /**
   * The name of the client.
   * @member {String} clientName
   */
  exports.prototype['clientName'] = undefined;
  /**
   * A collection of statistics groupped by client.
   * @member {Array.<module:model/StatisticsResponse>} data
   */
  exports.prototype['data'] = undefined;



  return exports;
}));



